import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbPaginationModule, NgbTypeaheadModule, NgbDropdownModule, NgbNavModule, NgbAccordionModule, NgbRatingModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

// Range Slider
import { NgxSliderModule } from '@angular-slider/ngx-slider';
// Simple bar
import { SimplebarAngularModule } from 'simplebar-angular';
// Swiper Slider
import { NgxUsefulSwiperModule } from 'ngx-useful-swiper';
// Ck Editer
// File Uploads
import { DropzoneModule } from 'ngx-dropzone-wrapper';
import { DROPZONE_CONFIG } from 'ngx-dropzone-wrapper';
import { DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
// Flat Picker
import { FlatpickrModule } from 'angularx-flatpickr';
// Ng Select
import { NgSelectModule } from '@ng-select/ng-select';
// Wizard
import { ArchwizardModule } from 'angular-archwizard';
// Apex Chart Package
import { NgApexchartsModule } from 'ng-apexcharts';
// Count
import { CountToModule } from 'angular-count-to';

// Load Icon
import { defineElement } from 'lord-icon-element';
import lottie from 'lottie-web';

// Component Pages
import { EcommerceRoutingModule } from './ecommerce-routing.module';
import { SharedModule } from '../../shared/shared.module';
import { CartComponent } from './cart/cart.component';
import { CheckoutComponent } from './checkout/checkout.component';
import { environment } from 'src/environments/environment';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';

const DEFAULT_DROPZONE_CONFIG: DropzoneConfigInterface = { // this is the main control for the file-upload module not sure why.

  // Where we should send the files (Default: null)
  url: environment.apiUrl + "/FileService/UploadStagingFile",

  // Whether the queue will be processed automatically
  autoProcessQueue: true,

  // How many file uploads to process in parallel (Default: null)
  parallelUploads: 1,

  // Name of the file parameter that gets transferred (Default: 'file')
  paramName: 'files',

  // Maximum file size for the upload files in megabytes (Default: null)
  maxFilesize: 250,

  // Comma separated list of mime types or file extensions (Default: null)
  acceptedFiles: '.txt, .pdf, .jpg, .gif, .doc, .docx, .xls, .xlsx, .csv, .png, .zip, .rar, .mp4',

  // Whether to send multiple files in one request (Default: null)
  uploadMultiple: true,

  // Whether thumbnails for images should be generated
  createImageThumbnails: true,

  // Whether to add a link to every file preview to remove or cancel (if already uploading) the file
  addRemoveLinks: true,
};


@NgModule({
  declarations: [
    CartComponent,
    CheckoutComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbPaginationModule,
    NgbTypeaheadModule,
    NgbDropdownModule,
    NgbNavModule,
    NgbAccordionModule,
    NgbRatingModule,
    NgbTooltipModule,
    NgxSliderModule,
    SimplebarAngularModule,
    NgxUsefulSwiperModule,
    DropzoneModule,
    FlatpickrModule.forRoot(),
    NgSelectModule,
    ArchwizardModule,
    NgApexchartsModule,
    CountToModule,
    EcommerceRoutingModule,
    NgxMaskDirective, 
    NgxMaskPipe,
    SharedModule
  ],
  providers: [
    provideNgxMask(),
    {
      provide: DROPZONE_CONFIG,
      useValue: DEFAULT_DROPZONE_CONFIG
    }
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class EcommerceModule { 
  constructor() {
    defineElement(lottie.loadAnimation);
  }
}
